"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketMessage = function TicketMessage(_ref) {
  var ticketsLink = _ref.ticketsLink;
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket"
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTwoCol, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColLeft, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Dont have a full ticket?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "Watch-only ticket holders can watch our conference live, but all other activities and video recordings are only available to full-access attendees. Upgrade your ticket and get to join Q&As with pro speakers, advice lounge with our experts, networking rooms, afterparty, and you\u2019ll also enjoy many other perks."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketButtonWithBorder, {
    href: ticketsLink,
    className: "pop-ticket__btn btn btn--border",
    target: "blank_"
  }, "Get one")), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColRight, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Have a full ticket?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "During conference days, enter your email assigned to the ticket order to unlock all features."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketForm, {
    action: "/live",
    method: "get",
    target: "_blank",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketField, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketInput, {
    type: "email",
    name: "email",
    placeholder: "Your email",
    className: "pop-ticket__input"
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketSubmitButton, {
    className: "pop-ticket__input_btn",
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unlock"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketArrowSvg, null, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "img/sprite.svg#icon-arrow-right"
  }))))))));
};

var _default = TicketMessage;
exports.default = _default;